import React from 'react';
import { X } from 'lucide-react';
import { Button } from './Button';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative flex flex-col w-full max-w-md max-h-[90dvh] rounded-2xl bg-bg-card shadow-xl border border-border-default">
        <div className="flex-none p-5 pb-4 flex items-center justify-between border-b border-border-default/30">
          <h3 className="text-xl font-bold text-text-heading">{title}</h3>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="h-5 w-5" />
          </Button>
        </div>
        <div className="flex-1 overflow-y-auto p-5 pt-4">
          {children}
        </div>
      </div>
    </div>
  );
};
